import {h, Fragment} from "preact"
import { useFacets, useProductFilters, useAppStateSelector, pick } from "@nosto/preact"

import SelectedFilters from "./SelectedFilters"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"

export default function SideBar({ sidebarRef, sidebarOpen, closeSidebar }) {
    const { response } = useAppStateSelector(state => pick(state, "response"))
    const { facets } = useFacets()
    const { filters, removeAll } = useProductFilters();
    const docCount = response.products?.total ?? 0

    return (facets?.length > 0) && (
        <aside 
            class="ns-sidebar ns-fixed ns-md-absolute ns-flex ns-flex-col ns-w-100 ns-h-100"
            id="ns-sidebar"
            role="dialog"
            aria-hidden={!sidebarOpen}
            aria-modal="true"
            aria-labelledby="ns-sidebar-heading"
            ref={sidebarRef}
        >
            <div class="ns-sidebar-header ns-lg-hidden ns-flex ns-justify-end">
                <h3 id="ns-sidebar-heading" class="sr-only">Filters</h3>
                <button
                    type="button"
                    onClick={closeSidebar}
                >
                    <span class="sr-only visually-hidden">Close filter list</span>
                    <svg aria-hidden="true" role="presentation" focusable="false" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 1.25L17.5 18.25" stroke="black" stroke-width="1.30769"/>
                        <path d="M17.5 1.25L0.5 18.25" stroke="black" stroke-width="1.30769"/>
                    </svg>
                </button>
            </div>

            <div class="ns-lg-hidden">
                <SelectedFilters />
            </div>

            <div class="ns-sidebar-body ns-page-width ns-w-100">
                <ul class="ns-list-unstyled ns-lg-flex ns-lg-justify-between">
                    {facets?.map(facet => {
                        switch (facet.type) {
                            case "terms":
                                return <Facet key={facet.id} facet={facet} />
                            case "stats":
                                return <RangeFacet key={facet.id} facet={facet} />
                            default:
                                return null
                        }
                    })}
                </ul>
            </div>
            <div class="ns-sidebar-footer-wrap">
                <div class="ns-sidebar-footer ns-flex ns-items-center ns-justify-between ns-lg-justify-start">
                    <button
                        class="ns-remove-filters-btn"
                        type="button"
                        disabled={filters.length < 1}
                        onClick={removeAll}
                    >
                        Clear All
                    </button>
                    <button
                        class="ns-close-btn"
                        type="button"
                        onClick={closeSidebar}
                    >
                        View ({docCount})
                    </button>
                </div>
            </div>
        </aside>
    )
}
